import { history } from '~/history';
import { initNativeI18n } from '~/i18n';
import { boot } from './bootstrap/boot';
import { mountApp } from './bootstrap/mountApp';
import { makeRenderRetryScreen } from './bootstrap/renderRetryScreen';
import { getNativePlatform, isNativePlatform } from './is-native';
const loadNative = ()=>import('./native');
void boot({
    isNativePlatform,
    getNativePlatform,
    addPlatformBodyClass: (platform)=>document.body.classList.add("capacitor-platform-".concat(platform)),
    loadNative,
    initNativeI18n,
    navigate: (path)=>history.push(path),
    mount: mountApp,
    renderRetry: makeRenderRetryScreen(loadNative)
});
